import { Employee, PermitFormBody } from "../../../contexts/interfaces";
import classes from "./ProfilePermitsPrint.module.css";
import { useTranslation } from "react-i18next";
import { convertDate } from "../../../utils/convertDate";

interface Props {
  employee: Employee;
}

const ProfilePermitsPrint = ({ employee }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        {t("profilePermits.nameAndBirthdate")}
      </div>
      <div className={classes.text}>
        {`${employee.firstName} ${employee.lastName} (${convertDate(
          employee.dateOfBirth
        )})`}
      </div>

      <div className={classes.title}>{t("profilePermits.registerNumber")}</div>
      <div className={classes.text}>
        {employee.registerNumber ||
          t("profileDetails.applicantDoesntHaveRegisterNumber")}
      </div>

      <div className={classes.title}>{t("profilePermits.jobTitles")}</div>
      <table>
        <tbody>
          <tr>
            <th>{t("profileDetails.jobTitle")}</th>
            <th>{t("profileDetails.unit")}</th>
          </tr>

          {/* Go through every unit/roles from unitRole -array and render new row into the table */}
          {employee.assignedRoles && employee.assignedRoles.length > 0
            ? employee.assignedRoles.map((role, i) => {
                return (
                  <tr key={i} className={classes.tableUnitRoleRow}>
                    <td className={classes.bolded}>{role.jobTitle}</td>
                    <td className={classes.bolded}>{role.unitName}</td>
                  </tr>
                );
              })
            : null}
        </tbody>
      </table>

      <div className={classes.title}>
        {t("profilePermits.validAccomplishments")}
      </div>
      {employee.accomplishments.map((acc, i) => {
        return (
          <div key={i} className={classes.text}>
            {`${acc.title} (${convertDate(acc.date || null)})`}
          </div>
        );
      })}

      <div className={classes.title}>{t("profilePermits.permits")}</div>
      <div className={classes.text}>
        {`Vanhenee: ${convertDate(employee.permitsValidUntil)}`}
      </div>

      <div className={classes.permitsContainer}>
        <div className={classes.dividerFirst} />
        {employee.permits.map((permit: PermitFormBody, i) => (
          <div key={i} className={classes.permitContainer}>
            <div className={classes.permitHeader}>{`${permit.fullTitle}:`}</div>
            <div className={classes.permitRow}>
              <div className={classes.permitColumn}>
                <div className={classes.permitHeader}>
                  {`${t("profilePermits.approvingDoctor")}:`}
                </div>
                <div>{permit.doctorName?.split("(")[0] || "Ei tiedossa"}</div>
                <div>
                  {`${t("profilePermits.DoctorUniqueIdCode")}: ${
                    permit.doctorUniqueIdCode || "Ei tiedossa"
                  }`}
                </div>
                <div>
                  {`${t("profilePermits.approveDate")}: ${
                    convertDate(permit?.approvedAt?.toString() || null) ||
                    "Ei tiedossa"
                  }`}
                </div>
              </div>
              <div className={classes.permitColumn}>
                <div className={classes.permitHeader}>
                  {`${t("profilePermits.demonstrations")}:`}
                </div>
                <div>
                  {permit.demonstrationAssessor1},{" "}
                  {convertDate(
                    permit?.demonstrationAssessor1Date?.toString() || null
                  )}
                </div>
                <div>
                  {permit.demonstrationAssessor2},{" "}
                  {convertDate(
                    permit?.demonstrationAssessor2Date?.toString() || null
                  )}
                </div>
                <div>
                  {permit.demonstrationAssessor3},{" "}
                  {convertDate(
                    permit?.demonstrationAssessor3Date?.toString() || null
                  )}
                </div>
              </div>
            </div>
            <div className={classes.divider} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfilePermitsPrint;
